export default __webpack_public_path__ + "static/media/closet2-2048w.a8ce0657.webp";